import { ALL_PERMISSIONS, Permission, ROLE_PERMISSION_MAP } from './permissions';

/**
 * Resolves a list of backend role strings into a Set of frontend permissions.
 * Pure function — no React or side-effect dependencies.
 */
export function resolvePermissions(roles: string[]): Set<Permission> {
  const permissions = new Set<Permission>();

  for (const role of roles) {
    const mapped = ROLE_PERMISSION_MAP[role];
    if (mapped) {
      for (const permission of mapped) {
        permissions.add(permission);
      }
    }
  }

  return permissions;
}

/** Returns a Set containing all defined permissions. Used for dev/security-disabled mode. */
export function resolveAllPermissions(): Set<Permission> {
  return new Set(ALL_PERMISSIONS);
}
